// PeptideVault v6.5 — Library seed data, categories

// ══════════════════════════════════════════════════════
// V3.0 SEED DATA & UTILITIES
// ══════════════════════════════════════════════════════
const PEPTIDE_LIBRARY_SEED = [
  { scientificName:'Tirzepatide',                         customVialName:'Weight Optimization Complex',      categories:['Weight Management / Metabolic'],     active:true, isBlend:false },
  { scientificName:'Tesamorelin',                         customVialName:'Body Composition Complex',         categories:['GH Axis / Body Composition'],        active:true, isBlend:false },
  { scientificName:'HGH / Somatropin',                    customVialName:'Growth Restoration Complex',       categories:['GH Axis / Growth Hormone'],          active:true, isBlend:false },
  { scientificName:'CJC-1295 + Ipamorelin',               customVialName:'GH Optimization Complex',          categories:['GH Axis / Growth Hormone'],          active:true, isBlend:true  },
  { scientificName:'Ipamorelin',                          customVialName:'Recovery Optimization Complex',    categories:['GH Axis / Recovery'],               active:true, isBlend:false },
  { scientificName:'MOTS-C',                              customVialName:'Mitochondrial Activation Complex', categories:['Mitochondrial / Energy'],            active:true, isBlend:false },
  { scientificName:'SS-31 / Elamipretide',                customVialName:'Cellular Restoration Complex',     categories:['Mitochondrial / Cellular Health'],   active:true, isBlend:false },
  { scientificName:'Epithalon / Epitalon',                customVialName:'Cellular Longevity Complex',       categories:['Cellular / Longevity'],               active:true, isBlend:false },
  { scientificName:'BPC-157',                             customVialName:'Tissue Repair Complex',            categories:['Recovery / Tissue Repair'],          active:true, isBlend:false },
  { scientificName:'TB-500',                              customVialName:'Systemic Recovery Complex',        categories:['Recovery / Tissue Repair'],          active:true, isBlend:false },
  { scientificName:'GHK-Cu',                              customVialName:'Tissue Renewal Complex',           categories:['Skin / Hair / Cosmetic'],            active:true, isBlend:false },
  { scientificName:'KPV',                                 customVialName:'Inflammation Control Complex',     categories:['Immune / Inflammation'],             active:true, isBlend:false },
  { scientificName:'SNAP-8',                              customVialName:'Expression Line Relaxer',          categories:['Skin / Hair / Cosmetic'],            active:true, isBlend:false },
  { scientificName:'KLOW',                                customVialName:'Radiance Recovery Blend',          categories:['Skin / Hair / Cosmetic'],            active:true, isBlend:true  },
  { scientificName:'Selank + Semax',                      customVialName:'Neural Optimization Blend',        categories:['Cognitive / Neurological'],          active:true, isBlend:true  },
  { scientificName:'5-Amino-1MQ',                        customVialName:'Metabolic Activation Complex',     categories:['Weight Management / Metabolic'],     active:true, isBlend:false },
  { scientificName:'VIP / Vasoactive Intestinal Peptide', customVialName:'Cellular Signaling Complex',       categories:['Immune / Inflammation'],             active:true, isBlend:false },
  { scientificName:'DSIP',                                customVialName:'Restorative Sleep Complex',        categories:['Sleep / Recovery'],                  active:true, isBlend:false },
]

// Starter templates — educational, editable, duplicatable
const PEPTIDE_CATEGORIES = [
  { id:'gh-axis',        label:'GH Axis / Growth Hormone',     desc:'Growth hormone, growth hormone–releasing analogs, and secretagogues acting on the GH/IGF-1 axis.', color:'#0072B2' },
  { id:'mito',           label:'Mitochondrial / Energy',        desc:'Compounds targeting mitochondrial structure, signaling, or cellular-energy pathways.', color:'#009E73' },
  { id:'recovery',       label:'Recovery / Tissue Repair',      desc:'Investigational peptides and blends grouped around wound-healing and tissue-repair research.', color:'#E69F00' },
  { id:'weight',         label:'Weight Management / Metabolic', desc:'Approved or investigational metabolic compounds grouped around weight, glucose, lipid, or body-composition pathways.', color:'#D55E00' },
  { id:'cognitive',      label:'Cognitive / Neurological',      desc:'Compounds grouped around central nervous system signaling, cognition, mood, or neurobiology.', color:'#CC79A7' },
  { id:'longevity',      label:'Cellular / Longevity',          desc:'Investigational peptides grouped around cellular maintenance, healthy-aging research, and longevity pathways.', color:'#56B4E9' },
  { id:'skin',           label:'Skin / Hair / Cosmetic',        desc:'Topical, cosmetic, pigmentation, or skin/hair-focused compounds and blends.', color:'#F0E442' },
  { id:'sleep',          label:'Sleep / Recovery',              desc:'Investigational compounds grouped around sleep physiology and recovery research.', color:'#000000' },
  { id:'immune',         label:'Immune / Inflammation',         desc:'Peptides grouped around immune signaling or inflammatory-pathway research.', color:'#999999' },
]

const CATEGORY_PALETTE = ['#0072B2','#E69F00','#009E73','#CC79A7','#56B4E9','#D55E00','#F0E442','#000000','#999999','#0072B2','#E69F00','#009E73','#CC79A7','#56B4E9']

// Returns all known categories: built-in + user-created + any in use on peptides, sorted A→Z
function getAllCategories() {
  const map = new Map()
  const overrides = (S.customCategories||[]).filter(c => c.builtinId || c.originalLabel)
  // Built-ins can be renamed and re-described through synced custom override records.
  for (const c of PEPTIDE_CATEGORIES) {
    const override = overrides.find(o => o.builtinId === c.id || o.originalLabel === c.label)
    const visible = override ? { ...c, ...override, id:c.id, builtin:true, editable:true } : { ...c, builtin:true, editable:true }
    map.set(visible.label, visible)
  }
  // User-created categories that are not built-in overrides.
  for (const c of (S.customCategories||[])) {
    if (c.builtinId || c.originalLabel) continue
    if (!map.has(c.label)) map.set(c.label, { id:'custom_'+c.label.replace(/[^a-z0-9]/gi,'-').toLowerCase(), label:c.label, desc:c.desc||'User-created category', color:c.color||pickCategoryColor(map.size), editable:true })
  }
  // Any category in use on an inventory peptide but not yet defined
  for (const p of (S.peptides||[])) {
    for (const cat of (p.categories||[])) {
      if (cat && !map.has(cat)) map.set(cat, { id:'used_'+cat.replace(/[^a-z0-9]/gi,'-').toLowerCase(), label:cat, desc:'User-created category', color:pickCategoryColor(map.size) })
    }
  }
  // Sort A→Z by label
  return [...map.values()].sort((a,b) => a.label.localeCompare(b.label))
}
function pickCategoryColor(i) { return CATEGORY_PALETTE[i % CATEGORY_PALETTE.length] }

// Resolve a category label to its assigned color
function categoryColor(label) {
  const cat = getAllCategories().find(c => c.label === label)
  return cat?.color || CATEGORY_PALETTE[0]
}

// Add a new custom category (called from the library modal)
function addCustomCategory(label, desc) {
  label = (label||'').trim()
  if (!label) return false
  const exists = getAllCategories().some(c => c.label.toLowerCase() === label.toLowerCase())
  if (exists) { showToast('That category already exists'); return false }
  if (!S.customCategories) S.customCategories = []
  if (!S.refillLog) S.refillLog = []
  S.customCategories.push({ label, color: pickCategoryColor(getAllCategories().length), desc: desc || 'User-created category' })
  logChange('category', null, 'created', `Created category "${label}"`)
  save()
  return true
}

function openCategoryAssign(label) {
  S._assignCategory = label
  openModal('categoryAssign')
}

function saveCategoryAssign() {
  const label = S._assignCategory
  if (!label) { closeModal(); return }
  let changed = 0
  document.querySelectorAll('[data-assign-pep]').forEach(cb => {
    const p = (S.peptides||[]).find(x => x.id === cb.dataset.assignPep)
    if (!p) return
    if (!p.categories) p.categories = []
    const has = p.categories.includes(label)
    if (cb.checked && !has) { p.categories.push(label); changed++ }
    else if (!cb.checked && has) { p.categories = p.categories.filter(c => c !== label); changed++ }
  })
  if (changed) {
    logChange('category', null, 'updated', `Updated peptide assignments for "${label}"`)
    save()
  }
  closeModal(); render()
  showToast(changed ? `Updated ${label}` : 'No changes')
}

function openCategoryEdit(label) {
  S._editCategory = label
  let cat = (S.customCategories||[]).find(c => c.label === label)
  if (!cat) {
    const builtin = getAllCategories().find(c => c.label === label && c.builtin)
    if (builtin) {
      if (!S.customCategories) S.customCategories = []
      cat = { label:builtin.label, desc:builtin.desc||'', color:builtin.color, builtinId:builtin.id, originalLabel:builtin.label }
      S.customCategories.push(cat)
    }
  }
  openModal('editCategory')
}

function saveCategoryEdit() {
  const oldLabel = S._editCategory
  const cat = (S.customCategories||[]).find(c => c.label === oldLabel)
  if (!cat) { closeModal(); return }
  const newLabel = document.getElementById('f-editcat-name')?.value?.trim() || ''
  const newDesc = document.getElementById('f-editcat-desc')?.value?.trim() || ''
  if (!newLabel) { showToast('Name required'); return }
  // Check for collision with a different category
  if (newLabel !== oldLabel && getAllCategories().some(c => c.label.toLowerCase() === newLabel.toLowerCase())) {
    showToast('A category with that name already exists'); return
  }
  cat.label = newLabel
  cat.desc = newDesc || 'User-created category'
  // Rename on all peptides that use the old label
  if (newLabel !== oldLabel) {
    for (const p of (S.peptides||[])) {
      if (p.categories?.includes(oldLabel)) {
        p.categories = p.categories.map(c => c === oldLabel ? newLabel : c)
      }
    }
  }
  logChange('category', null, 'updated', `Renamed category "${oldLabel}" to "${newLabel}"`)
  save(); closeModal(); render()
  showToast('Category updated')
}

function saveNewCategory() {
  const label = document.getElementById('f-newcat-name')?.value?.trim() || ''
  const desc = document.getElementById('f-newcat-desc')?.value?.trim() || ''
  if (!label) { showToast('Enter a category name'); return }
  if (!addCustomCategory(label, desc)) return  // shows toast if duplicate
  closeModal(); render()
  showToast(`Category "${label}" created`)
}

async function deleteCustomCategory(label) {
  const inUse = (S.peptides||[]).filter(p => (p.categories||[]).includes(label)).length
  const msg = inUse > 0
    ? `Delete the category "${label}"? ${inUse} peptide${inUse!==1?'s':''} assigned to it will become unassigned. Continue?`
    : `Delete the category "${label}"?`
  if (!await asyncConfirm(msg)) return
  // Remove the label from all peptides (moves them to unassigned)
  for (const p of (S.peptides||[])) {
    if (p.categories?.includes(label)) p.categories = p.categories.filter(c => c !== label)
  }
  S.customCategories = (S.customCategories||[]).filter(c => c.label !== label)
  logChange('category', null, 'deleted', `Deleted category "${label}"${inUse?` (${inUse} peptides unassigned)`:''}`)
  save(); render()
  showToast(`Category "${label}" deleted`)
}

// Utility: log a change event
function logChange(entityType, entityId, action, description) {
  if (!S.changeLog) S.changeLog = []
  S.changeLog.unshift({
    id:          'cl_' + uid(),
    createdAt:   now(),
    entityType,
    entityId,
    action,
    description,
  })
  // Keep last 500 entries
  if (S.changeLog.length > 500) S.changeLog = S.changeLog.slice(0, 500)
}

// Utility: get user by id
function getUser(id) { return S.users?.find(u => u.id === id) }
function getUserColor(id) { return getUser(id)?.color || 'var(--text4)' }
function getUserInitials(id) { return getUser(id)?.initials || id?.slice(0,2).toUpperCase() || '?' }

// Utility: find library entry for a peptide name (fuzzy — handles dosage suffixes, hyphens, case)
function normalizePeptideName(name) {
  if (!name) return ''
  return name
    .toLowerCase()
    .replace(/\d+\s*(mg|mcg|iu|ml|g)\b/g, '')   // strip dosage suffixes like "20mg", "50 mg"
    .replace(/[^a-z0-9]+/g, '')                  // strip all non-alphanumeric (hyphens, spaces, slashes, +)
    .trim()
}

function findLibraryEntry(name) {
  if (!name || !S.peptideLibrary?.length) return null
  const n = name.toLowerCase().trim()
  // 1. Exact match (scientific name, vial name, or alias)
  let match = S.peptideLibrary.find(e =>
    e.scientificName?.toLowerCase() === n ||
    e.customVialName?.toLowerCase() === n ||
    (e.aliases || []).some(a => a.toLowerCase() === n)
  )
  if (match) return match
  // 2. Normalized match (strips dosage suffixes, hyphens, spacing)
  const normN = normalizePeptideName(name)
  if (!normN) return null
  match = S.peptideLibrary.find(e => {
    const candidates = [e.scientificName, e.customVialName, ...(e.aliases||[])]
    return candidates.some(c => c && normalizePeptideName(c) === normN)
  })
  if (match) return match
  // 3. Partial/contains match as last resort (only if normalized name is reasonably specific)
  if (normN.length >= 3) {
    match = S.peptideLibrary.find(e => {
      const sci = normalizePeptideName(e.scientificName)
      return sci && (normN.includes(sci) || sci.includes(normN))
    })
  }
  return match || null
}

// Sync: create stub library entries for any peptide that has no library match
// Find a seed entry whose name/alias matches (fuzzy) — used to backfill vial names
function findSeedMatch(name) {
  if (!name) return null
  const normN = normalizePeptideName(name)
  return PEPTIDE_LIBRARY_SEED.find(s => {
    const cands = [s.scientificName, s.customVialName, ...(s.aliases||[])]
    return cands.some(c => c && normalizePeptideName(c) === normN)
  }) || PEPTIDE_LIBRARY_SEED.find(s => {
    const sci = normalizePeptideName(s.scientificName)
    return sci && normN.length >= 3 && (normN.includes(sci) || sci.includes(normN))
  }) || null
}

function syncLibraryFromInventory() {
  let created = 0, filled = 0
  // 1. Backfill blank vial names on existing entries from seed data
  for (const e of S.peptideLibrary) {
    if (!e.customVialName || !e.customVialName.trim()) {
      const seed = findSeedMatch(e.scientificName)
      if (seed?.customVialName) {
        e.customVialName = seed.customVialName
        if (!e.categories?.length && seed.categories) e.categories = [...seed.categories]
        filled++
      }
    }
  }
  // 2. Create entries for inventory peptides with no library match
  for (const p of S.peptides) {
    if (findLibraryEntry(p.name)) continue
    const seed = findSeedMatch(p.name)
    S.peptideLibrary.push({
      id: 'lib_' + uid(),
      scientificName: p.name,
      customVialName: p.customVialName || seed?.customVialName || '',
      aliases: [],
      categories: seed?.categories ? [...seed.categories] : [],
      isBlend: p.isBlend || seed?.isBlend || false,
      active: true,
    })
    created++
  }
  if (created || filled) {
    logChange('library', null, 'updated', `Library sync: ${created} added, ${filled} vial name${filled!==1?'s':''} filled`)
    save(); render()
    showToast(`Sync complete — ${created} added, ${filled} vial name${filled!==1?'s':''} filled`)
  } else {
    showToast('Library is already complete')
  }
}

// Remove duplicate library entries (same normalized scientific name), keeping the most complete
function dedupeLibrary() {
  const seen = new Map()  // normalized name -> entry
  const keep = []
  for (const e of S.peptideLibrary) {
    const key = normalizePeptideName(e.scientificName)
    const existing = seen.get(key)
    if (!existing) {
      seen.set(key, e); keep.push(e)
    } else {
      // Merge: prefer the entry that has a vial name / categories
      const score = x => (x.customVialName?1:0) + ((x.categories?.length)?1:0)
      if (score(e) > score(existing)) {
        if (!existing.customVialName && e.customVialName) existing.customVialName = e.customVialName
        if (!existing.categories?.length && e.categories?.length) existing.categories = e.categories
      } else {
        if (!existing.customVialName && e.customVialName) existing.customVialName = e.customVialName
        if (!existing.categories?.length && e.categories?.length) existing.categories = e.categories
      }
    }
  }
  const removed = S.peptideLibrary.length - keep.length
  S.peptideLibrary = keep
  if (removed) {
    logChange('library', null, 'deleted', `Removed ${removed} duplicate library entr${removed!==1?'ies':'y'}`)
    save(); render()
    showToast(`Removed ${removed} duplicate${removed!==1?'s':''}`)
  } else {
    showToast('No duplicates found')
  }
}

export {
  PEPTIDE_LIBRARY_SEED,
  PEPTIDE_CATEGORIES,
  CATEGORY_PALETTE,
  getAllCategories,
  pickCategoryColor,
  categoryColor,
  addCustomCategory,
  openCategoryAssign,
  saveCategoryAssign,
  openCategoryEdit,
  saveCategoryEdit,
  saveNewCategory,
  deleteCustomCategory,
  logChange,
  getUser,
  getUserColor,
  getUserInitials,
  normalizePeptideName,
  findLibraryEntry,
  findSeedMatch,
  syncLibraryFromInventory,
  dedupeLibrary
}
